import * as React from 'react';
import { Button, Text, Flex, Segment, Loader, Header, Tooltip, Dialog, List, Label } from '@fluentui/react-northstar';
import { ArrowLeftIcon, CloseIcon, ArrowRightIcon, SearchIcon, OpenOutsideIcon, MegaphoneIcon, InfoIcon } from '@fluentui/react-icons-northstar';
import { CaseType } from '../helpers/constants';
import Styles from '../styles/Styles';
import SearchBox from './SearchBox';
import axios from 'axios';
import AuthHelper from '../helpers/Auth-Helper';
import { HttpRequest, RequestHeaders } from '../helpers/HttpRequest';
import * as Functions from '../helpers/Functions';
import { Helpers } from '../helpers/Helpers';
var currentData;
var modelMap = new Map();
var dialogMessage = "";
var channelsListMemberOf = [];
var channelsListNotMemberOf = [];
var channelsExistContent = "";
class SearchCase extends React.Component<ISearchProps, ISearchState> {
    fromHome: boolean;
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            openDialog: false,
            didItemSelected: false,
            didChannelsExist: false,
            selectedIndex: -1,
            isLoadingNext: false,
            loaderLabel: 'Checking status',
            isCaseExisted: false
        };
        this.fromHome = Helpers.getUrlPar("fromHome") === "true";

        this.handleClickNext = this.handleClickNext.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleSelectItem = this.handleSelectItem.bind(this);
        this.didConfirmed = this.didConfirmed.bind(this);
        this.didCancelled = this.didCancelled.bind(this);
        this.openCaseButton = this.openCaseButton.bind(this);
        this.didSelectAnExistedChannel = this.didSelectAnExistedChannel.bind(this);
    }
    componentDidMount() {
        var logginInterval = setInterval(async () => {
            var urlArray = window.location.href.split('/');
            var relativeUrl = urlArray[urlArray.length - 1];
            if (this.props.isMobile) {
                var authData = await AuthHelper.IsUserLoggedIn(this.props.isMobile);
                if (!authData.isLoggedIn || !authData.isLicensed) {
                    window.location.href = 'signin?from=' + relativeUrl;
                }
            }
            else {
                clearInterval(logginInterval);
            }
        }, 3000);
        console.log('ID: ' + this.props.id);
        this.getCaseDetailsById();
    }
    async getCaseDetailsById() {
        if (this.props.id != null && this.props.id.length > 0) {
            this.setState({ isLoading: true});
            var caseType = window.location.pathname.replace('/', '');
            var apiUrl = '';
            try {
                switch (caseType) {
                    case 'casesmeet': {
                        apiUrl = '/modules/api/cases/edit/' + this.props.id;
                        var response = await HttpRequest.get(apiUrl);
                        var caseValues = response?.data?.success?.data?.caseValues;
                        if (caseValues != null) {
                            currentData = {
                                key: String(caseValues.id),
                                header: String('M' + caseValues.id + ': ' + Functions.strip_html_tags(caseValues.subject)),
                                content: String((caseValues.category == 'Matter') ? CaseType.matter : CaseType.litigation),
                                image: { src: require('../Images/' + caseValues.category + '.svg') }
                            };
                        }
                    } break;
                    case 'contractmeet': {
                        apiUrl = '/modules/api/contracts/edit/' + this.props.id;
                        var response = await HttpRequest.get(apiUrl);
                        var caseValues = response?.data?.success?.data?.contract?.contract;
                        if (caseValues != null) {
                            currentData = {
                                key: String(caseValues.id),
                                header: String('CT' + caseValues.id + ": " + Functions.strip_html_tags(caseValues.name)),
                                content: String(CaseType.contract),
                                image: { src: require('../Images/' + CaseType.contract + '.svg') }
                            };
                        }
                    } break;
                    case 'hearingmeet': {
                        apiUrl = '/modules/api/hearings/edit/' + this.props.id;
                        var response = await HttpRequest.get(apiUrl);
                        var caseValues = response?.data?.success?.data?.hearingValues;
                        if (caseValues != null) {
                            var hearingDate = '[';
                            var startDate = caseValues.startDate;
                            var startTime = (caseValues.startTime)?.substring(0, 5);
                            if (startDate != null) {
                                hearingDate += startDate;
                            }
                            if (startTime != null) {
                                hearingDate += ' ' + startTime;
                            }
                            hearingDate += ']';
                            currentData = {
                                key: String(this.props.id + ':' + caseValues.legal_case_id),
                                header: String(Functions.strip_html_tags(caseValues?.legalCaseSubject) + ' ' + hearingDate + ' ' + ((caseValues.type?.name != null) ? caseValues.type?.name : "")),
                                content: String(CaseType.hearing),
                                image: { src: require('../Images/Litigation.svg') }
                            };
                        }
                    } break;
                }
                this.setState({ didItemSelected: true });
            }
            catch (err) {

            }            
            this.handleSearchClick();
        }
    }
    getCaseTypeName() {
        switch (this.props.type) {
            case CaseType.contract: case CaseType.hearing: return this.props.type;
            default: return "Matter";
        }
    }    
    handleSearchClick() {        
        if (currentData != null) {
            this.setState({ isLoading: true, isCaseExisted: (this.props.id != null && this.props.id.length > 0) ? true : false });
            var url;
            switch (this.props.redirectPage) {
                case 'casesmeet': url = '/Cases/Meet'; break;
                case 'hearingmeet': url = '/Hearing/Meet'; break;
                case 'contractmeet': url = '/Contracts/Meet'; break;
                default: break;
            }
            let config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }
            let params = new URLSearchParams();
            modelMap = new Map<string, string>();
            if (currentData.content == CaseType.hearing) {
                var hearingAndcaseIds = currentData.key.split(':');
                var hearingId = hearingAndcaseIds[0];
                var caseId = hearingAndcaseIds[1];
                modelMap.set('CaseId', caseId);
                modelMap.set('HearingId', hearingId);
            }
            else {
                if (currentData.content == CaseType.contract) {
                    modelMap.set('ContractId', currentData.key);
                }
                else {
                    modelMap.set('CaseId', currentData.key);
                }
            }
            modelMap.set('CaseName', currentData.header);
            modelMap.set('CaseCategory', currentData.content);
            modelMap.forEach(function (value, key) {
                params.append(key, value);
            });
            axios.post(url, params, config).then((resp) => {
                try {
                    var response = resp.data;
                    switch (response.code) {
                        case "Error":
                            {
                                dialogMessage = response.message;
                                this.setState({ openDialog: true, isLoading: false });
                            }
                            break;
                        case "CreateChannel":
                            {
                                var url = this.props.redirectPage + 'create';
                                window.location.href = url;
                            } break;
                        case "RedirectToChannel":
                            {
                                channelsListMemberOf = [];
                                channelsListNotMemberOf = [];
                                channelsExistContent = "Channels with same " + this.props.type + " id: " + ((this.props.type == CaseType.contract) ? modelMap.get('ContractId') :
                                    ((this.props.type == CaseType.hearing) ? modelMap.get('HearingId') : modelMap.get('CaseId'))) + " already exist. Choose one to redirect to it or click Next to create a new one";
                                response.message.forEach(channel => {
                                    if (channel.link.length > 0)
                                        channelsListMemberOf.push({
                                            key: channel.link,
                                            header: channel.name,
                                            content: "",
                                            media: <ArrowRightIcon />
                                        });
                                    else
                                        channelsListNotMemberOf.push({
                                            key: Math.floor(Math.random() * 1000000000),
                                            header: channel.name,
                                            content: "You are not a member in this channel",
                                        });
                                });
                                this.setState({ didChannelsExist: true, isLoading: false });
                            } break;
                        case "CreatingTeam":
                            {
                                this.setState({ loaderLabel: 'Creating team for the first time. This may take a while, please wait...', isLoading: true });
                                var url = '';
                                switch (this.props.redirectPage) {
                                    case 'casesmeet': url = '/Cases/CreatingTeam'; break;
                                    case 'hearingmeet': url = '/Hearing/CreatingTeam'; break;
                                    case 'contractmeet': url = '/Contracts/CreatingTeam'; break;
                                }
                                axios.get(url).then((resp) => {
                                    var response = resp.data;
                                    switch (response.code) {
                                        case "Error":
                                            {
                                                dialogMessage = response.message;
                                                this.setState({ openDialog: true, isLoading: false });
                                            }
                                            break;
                                        case "CreateChannel":
                                            {
                                                url = '/' + this.props.redirectPage + 'create';
                                                window.location.href = url;
                                            } break;
                                        default:
                                            {
                                                dialogMessage = 'Something wrong!';
                                                this.setState({ openDialog: true, isLoading: false });
                                            } break;
                                    }
                                });
                            } break;
                    }
                }
                catch (err) {
                    console.log(err);
                    dialogMessage = 'Something wrong!';
                    this.setState({ openDialog: true, isLoading: false });
                }
            }).catch(error => {
                dialogMessage = 'Something wrong!';
                this.setState({ openDialog: true, isLoading: false });
            });
        }
        else {
            dialogMessage = 'Id not found';
            this.setState({ openDialog: true, isLoading: false });
        }
    }
    handleClickNext() {
        var url = '';
        switch (this.props.redirectPage) {
            case 'casesmeet': url = '/Cases/DuplicateChannel'; break;
            case 'hearingmeet': url = '/Hearing/DuplicateChannel'; break;
            case 'contractmeet': url = '/Contracts/DuplicateChannel'; break;
        }
        this.setState({ isLoadingNext: true });
        let config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }
        let params = new URLSearchParams();  
        modelMap.forEach(function (value, key) {
            params.append(key, value);
        });
        axios.post(url, params, config)
            .then(response => {
                var resp = response.data;
                var code = resp.code;
                switch (code) {
                    case "CreateChannel": {
                        var url = '/' + this.props.redirectPage + 'create';
                        window.location.href = url;
                    } break;
                }
            });
    }
    handleSelectItem(data) {
        if (data != null) {
            if (data.value == null) {
                currentData = null;
                this.setState({ didItemSelected: false, didChannelsExist: false });
            }
            else {
                currentData = data.value;
                this.setState({ didItemSelected: true });                
            }           
        }        
    }
    didConfirmed() {
        this.setState({ openDialog: false });
    }
    didCancelled() {
        this.setState({ openDialog: false });
    }
    didSelectAnExistedChannel() {
        if (this.state.selectedIndex != -1) {
            if (channelsListMemberOf.length > 0) {
                this.props.executeDeepLink(channelsListMemberOf[this.state.selectedIndex].key)
            }
        }
    }
    openCaseButton() {
        var url = new RequestHeaders().url;
        if (currentData != null) {
            switch (currentData.content) {
                case CaseType.matter: case CaseType.litigation:
                    {
                        url += '/cases/edit/' + currentData.key;
                    } break;
                case CaseType.hearing:
                    {
                        var id = currentData.key.split(':')[1];
                        url += '/cases/edit/' + id;
                    } break;
                case CaseType.contract:
                    {
                        url += '/modules/contract/contracts/view/' + currentData.key;
                    } break;
            }
            window.open(url);
        }
    }
    render() {
        const title = "Select a " + this.getCaseTypeName() + " to start a meeting";
        return (
            <Flex column hAlign="center" vAlign="center" styles={Styles.parentStyle}>
                <Flex gap="gap.medium" column hAlign="center" vAlign="center" key="center" styles={Styles.layoutStyle}>
                    <Segment color='brand' styles={{
                        boxShadow: "0 2px 5px 2px rgba(0,0,0,.24), 0 17px 50px 0 rgba(0,0,0,.19)", width: '100%'
                    }}
                        content={<Flex hAlign="center" vAlign="center" styles={{ width: '100%' }}>
                            <Flex column gap="gap.large" styles={{ width: '100%' }}>
                                <Flex style={{justifyContent: this.fromHome ? 'space-between' : 'center'}} vAlign="center">
                                    {this.fromHome && <Button icon={<ArrowLeftIcon />} iconOnly onClick={() => {
                                        window.location.href = '/base';
                                    }} style={{ width: '40px' }} />}
                                    <Header as={this.props.isMobile ? "h3" : "h1"} style={{fontWeight: 600, fontSize: '18px'}} content={title} />
                                    {this.fromHome && <div></div>}
                                </Flex>
                                <Flex inline={!this.props.isMobile} column={this.props.isMobile} hAlign="center" vAlign="center" gap="gap.medium">
                                    <Text weight='bold' content={this.getCaseTypeName() + " name"} />
                                    <Flex hAlign='center' vAlign='center' styles={{ width: this.props.isMobile ? "100%" : "70%"}}>
                                        {this.state.isCaseExisted ?
                                            <Tooltip content={currentData?.header} trigger={
                                                <Label
                                                    content={
                                                        <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                            {currentData?.header}
                                                        </div>}
                                                    fluid
                                                    image={{
                                                        src: require('../Images/' + Functions.getCaseDetailsImage(currentData?.content) + '.png'),
                                                        avatar: true,
                                                    }}
                                                    icon={<CloseIcon onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ isCaseExisted: false }) }} />
                                                    }
                                                />
                                            }/>   
                                            :
                                        <SearchBox isMultiple={false} isSearching={this.state.isLoading || this.state.isLoadingNext} onSelectItem={this.handleSelectItem} type={this.props.type} items={[]} errorAPI={this.props.errorAPI} />}
                                    </Flex>
                                    <Flex gap='gap.medium'>
                                        <Tooltip content={`Open in ${Helpers.getAppName()}`} trigger={<Button icon={<OpenOutsideIcon />} iconOnly onClick={this.openCaseButton} disabled={!this.state.didItemSelected} />} />
                                        <Tooltip content={`Need to create a new one? Press to open ${Helpers.getAppName()} core and start creating it.`} trigger={<Button icon={<InfoIcon />} iconOnly onClick={(e, props) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            window.open(new RequestHeaders().url);
                                        }} />} />
                                    </Flex>
                                </Flex>
                                <Flex hAlign="center" vAlign="center" gap="gap.large" styles={{ marginBottom: '10px' }}>
                                    {(this.state.isLoading) ?
                                        <Loader size="medium" label={this.state.loaderLabel} labelPosition="below" />
                                        :
                                        <Button primary icon={<SearchIcon />} onClick={this.handleSearchClick} disabled={this.state.isLoadingNext || !this.state.didItemSelected} content='Search' />
                                    }
                                </Flex>
                            </Flex>
                        </Flex>
                        }
                        />       
                    {this.state.didChannelsExist && this.state.didItemSelected ?
                        <Segment color='green' styles={{
                        boxShadow: "0 2px 5px 2px rgba(0,0,0,.24), 0 17px 50px 0 rgba(0,0,0,.19)", width: '100%'
                    }}
                        content={<Flex hAlign="center" vAlign="center" styles={{ width: '100%' }}>
                            <Flex column gap="gap.large" styles={{ width: '100%' }}>
                                <Flex inline={!this.props.isMobile} column={this.props.isMobile} hAlign="center" vAlign="center" gap='gap.medium'>
                                    <MegaphoneIcon />
                                    <Text content={channelsExistContent} />
                                </Flex>
                                <Flex inline={!this.props.isMobile} column={this.props.isMobile} hAlign="center" vAlign="center" gap="gap.medium">
                                    {channelsListMemberOf.length > 0 ?
                                                <Segment color='brand'
                                                    content={<List
                                                        selectable
                                                        selectedIndex={this.state.selectedIndex}
                                                        onSelectedIndexChange={(e, newProps) => {
                                                            this.setState({
                                                                selectedIndex: newProps.selectedIndex,
                                                            })
                                                            this.didSelectAnExistedChannel();
                                                        }}
                                                        items={channelsListMemberOf}
                                                    />}
                                                /> : <div />}
                                            {channelsListNotMemberOf.length > 0 ?
                                                <Segment color='orange'
                                                    content={<List
                                                        items={channelsListNotMemberOf}
                                                        styles={{ color: "red" }}
                                                    />}
                                                /> : <div />}
                                </Flex>
                                <Flex hAlign="center" vAlign="center" gap="gap.large" styles={{ marginBottom: '10px' }}>
                                   {this.state.isLoadingNext ? <Loader /> :
                                            <Button primary icon={<ArrowRightIcon />} onClick={this.handleClickNext} content='Next'/>
                                            }
                                </Flex>
                            </Flex>
                        </Flex>
                        }
                        /> 
                         : <div/>}
                </Flex>
                    <Dialog
                        open={this.state.openDialog}
                        header='Information'
                        content={dialogMessage}
                        confirmButton={null}
                        cancelButton="Cancel"
                        onConfirm={this.didConfirmed}
                        onCancel={this.didCancelled}
                    />
            </Flex>
            );
    }
}
export default SearchCase;

const alignment = {
    hAlign: "center",
    vAlign: "center",
};
interface ISearchProps {
    type: string;    
    redirectPage: string;
    executeDeepLink(link);
    errorAPI(code);
    isMobile: boolean;
    id: string;
}
interface ISearchState {
    isLoading: boolean;
    loaderLabel: string;
    openDialog: boolean;
    didItemSelected: boolean;
    didChannelsExist: boolean;
    selectedIndex: number;
    isLoadingNext: boolean;
    isCaseExisted: boolean;
}